import { useState } from "react";
import Tabs from "../../../components/tabs/Tabs";
import PaidPayments from "./PaidPayments/PaidPayments";
import UnPaidPayments from "./UnpaidPayments/UnpaidPayments";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const TrackingPayments = () => {

  const items = [
    {
      key: "1",
      label: "Unpaid",
      // headerTitle: "Event Detail",
      children: (
        <UnPaidPayments
        />
      ),
    },
    {
      key: "2",
      label: "Paid",
      children: <PaidPayments />,
    },
  ];

  return <BoxTabs items={items} destroyOnBlur />;
};

export default TrackingPayments;
